<template>
  <section>
    <b-card>
      <template #header>
        <div class="d-flex align-items-center">
          <span class="text-primary">In vendita al rivenditore </span>
          <b-breadcrumb class="ml-2">
            <b-breadcrumb-item>
              <feather-icon
                icon="HomeIcon"
                scale="1.25"
                shift-v="1.25"
              ></feather-icon>
            </b-breadcrumb-item>
            <b-breadcrumb-item active> Parco Auto</b-breadcrumb-item>
            <b-breadcrumb-item active> In vendita al rivenditore</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </template>

      <b-table
        class="mt-2"
        :fields="fields"
        :items="items"
        :busy="loading"
        show-empty
        responsive
        striped
      >
         <template #table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.key == 'opzioni' ? '800px' : '180px' }"
          >
         </template>
        <template #table-busy>
          <div class="text-center text-primary-light my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Caricamento dati delle auto...</strong>
          </div>
        </template>
        <template #cell(id)="data">
          {{ data.item.id_auto }}
        </template>
        <template #cell(marca)="data">
          {{ data.item.marca }}  
        </template>
        <template #cell(modello)="data">
          {{ data.item.modello }}
        </template>
        <template #cell(versione)="data">
          {{ data.item.versione }}
        </template>
        <template #cell(anno)="data">
          {{ data.item.immatricolazione_anno }}
        </template>
        <template #cell(km)="data">
          {{ data.item.chilometraggio }}
        </template>
        <template #empty>
          <div class="text-center">
            <h5>Non ci sono auto da mostrare</h5>
          </div>
        </template>
        <template #cell(opzioni)="data">
          
          <span class="mr-2 text-nowrap">
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template #button-content>
                <feather-icon
                  style="color: gray"
                  size="20"
                  icon="LayersIcon"
                ></feather-icon>
              </template>
              <b-dropdown-item @click="$refs.vehicle_photo_modal.open(data.item.id_auto)">Foto</b-dropdown-item>
              <b-dropdown-item @click="$refs.vehicle_photo_examination_modal.open(data.item.id_auto)">Foto Perizia</b-dropdown-item>
              <b-dropdown-item>Dettagli Auto</b-dropdown-item>
              <b-dropdown-item @click="$refs.vehicle_documents_modal.open(data)">Documenti Associati</b-dropdown-item>
            </b-dropdown>

            <b-dropdown
              class="mx-2"
              size="sm"
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template #button-content>
                <feather-icon
                  style="color: gray"
                  size="20"
                  icon="EditIcon"
                ></feather-icon>
              </template>
              <b-dropdown-item @click="$refs.vehicle_photo_edit_modal.open(data)">Modifica Foto</b-dropdown-item>
              <b-dropdown-item @click="$refs.vehicle_photo_examination_edit_modal.open(data)">Modifica Foto Perizia</b-dropdown-item>
              <b-dropdown-item>Modifica Dettagli Auto</b-dropdown-item>
              <b-dropdown-item @click="$refs.vehicle_documents_edit_modal.open(data)">Modifica Documenti Associati</b-dropdown-item>
              <b-dropdown-item @click="$refs.vehicle_costs_edit_modal.open(data)">Modifica Costi</b-dropdown-item>
              <b-dropdown-item>Modifica Optionals</b-dropdown-item>
              <b-dropdown-item>Modifica Prezzi</b-dropdown-item>
              <b-dropdown-item @click="$refs.vehicle_status_edit_modal.open(data)">Modifica Status</b-dropdown-item>
              <b-dropdown-item @click="$refs.vehicle_location_edit_modal.open(data.item.ubicazione)">Modifica Ubicazione</b-dropdown-item>
            </b-dropdown>

            <b-dropdown
              size="sm"
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template #button-content>
                <feather-icon
                  style="color: gray"
                  size="20"
                  icon="FileTextIcon"
                ></feather-icon>
              </template>
              <b-dropdown-item>Stampa Scheda</b-dropdown-item>
              <b-dropdown-item @click="$refs.vehicle_reservation_list_modal.open(data.item.id_auto)">Elenco Prenotazioni</b-dropdown-item>
              <b-dropdown-item>Gestione Pratiche</b-dropdown-item>
              <b-dropdown-item>Gestione Finanziamenti</b-dropdown-item>
            </b-dropdown>

          </span>

        </template>
      </b-table>
    </b-card>

    <!-- Modali -->

    <vehicle-price-set-modal ref="vehicle_price_set_modal"/>
    <vehicle-costs-edit-modal ref="vehicle_costs_edit_modal" />
    <vehicle-photo-edit-modal ref="vehicle_photo_edit_modal"/>
    <vehicle-photo-examination-edit-modal ref="vehicle_photo_examination_edit_modal" />
    <vehicle-documents-modal ref='vehicle_documents_modal'/>
    <vehicle-photo-modal ref="vehicle_photo_modal" />
    <vehicle-documents-edit-modal ref="vehicle_documents_edit_modal" />
    <vehicle-status-edit-modal ref="vehicle_status_edit_modal" />
    <vehicle-location-edit-modal ref="vehicle_location_edit_modal" />
    <vehicle-reservation-list-modal ref="vehicle_reservation_list_modal" />

  </section>
</template>

<script>
import {
  BButton,
  BBreadcrumb,
  BBreadcrumbItem,
  BCard,
  BCardTitle,
  BIcon,
  BDropdown,
  BDropdownItem,
  BTable,
  BModal,
  BForm,
  BFormInput,
  BFormGroup,
  BSpinner,
} from "bootstrap-vue";

import {  
  VehiclePriceSetModal,
  VehicleCostsEditModal,
  VehicleDocumentsModal,
  VehicleDocumentsEditModal,
  VehiclePhotoEditModal,
  VehiclePhotoExaminationEditModal,
  VehiclePhotoModal,
  VehicleStatusEditModal,
  VehicleLocationEditModal,
  VehicleReservationListModal,
} from '@/components/modals'

import { Requests } from "@/api";

export default {
  components: {
    BButton,
    BBreadcrumb,
    BBreadcrumbItem,
    BCard,
    BCardTitle,
    BIcon,
    BDropdown,
    BDropdownItem,
    BTable,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BSpinner,
    VehiclePriceSetModal,
    VehicleCostsEditModal,
    VehicleDocumentsModal,
    VehicleDocumentsEditModal,
    VehiclePhotoModal,
    VehiclePhotoEditModal,
    VehiclePhotoExaminationEditModal,
    VehicleStatusEditModal,
    VehicleLocationEditModal,
    VehicleReservationListModal,
  },

  data: () => ({
    fields: [
      { key: "id", sortable: true },
      { key: "marca", sortable: true },
      { key: "modello", sortable: true},
      { key: "versione", sortable: true},
      { key: "anno", sortable: true },
      { key: "km", sortable: true },
      { key: "targa", sortable: true },
      { key: "telaio", sortable: true },
      { key: "colore", sortable: true },
      "opzioni",
    ],

    items: [],

    //Helpers

    loading: false,
  }),

  created() {
    this.getAutoOnSale();
  },

  methods: {
    async getAutoOnSale() {
      this.loading = true;

      try {
        const response = await Requests.getAutoOnSale('seller_resellerprice');
        this.items = response;
      } catch {
        console.debug(err);
      }

      this.loading = false;
    },
  },
};
</script>

<style>
.b-dropdown button {
  padding: 0;
}
</style>

<style lang="scss">
    @import "@core/scss/vue/libs/vue-select.scss";
</style>
